import { useQuery } from '@apollo/client';
import { SELECT_MODEL_PORTFOLIO_EDIT_TYPE_FETCH_HOUSEHOLD } from '../selectModelPortfolioEditType.queries';

export const useHouseholdAccountCount = (clientGroupId?: string) => {
  const { data, error } = useQuery(
    SELECT_MODEL_PORTFOLIO_EDIT_TYPE_FETCH_HOUSEHOLD,
    {
      // biome-ignore lint/style/noNonNullAssertion: skip below keeps the query from running without an id
      variables: { clientGroupId: clientGroupId! },
      skip: !clientGroupId,
      fetchPolicy: 'network-only',
    },
  );

  return {
    count: data?.fetchPortfolioReports.portfolioReports[0]?.subAccounts.length,
    error,
  };
};
